import { createApp } from 'vue';
import App from '../App.vue';
import router from '../router';
import axios from 'axios';
import { initializeTokenRefresh } from '../services/tokenRefreshService';
import '../stylesheets/application.css';
import '../stylesheets/toast.css';
import toastPlugin from '../plugins/toast';
import { pinia } from '../stores/pinia.js';

// Configure axios defaults
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.withCredentials = true;

// Set the base URL for API requests
const csrfToken = document.querySelector('meta[name="csrf-token"]');
if (csrfToken) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.getAttribute('content');
}

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(toastPlugin);

// Initialize token refresh mechanism early - this sets up axios interceptors
initializeTokenRefresh();

if (document.getElementById('app')) {
  app.mount('#app');
}
